import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { INTERNAL_NOTE } from "MODULES/shared/constants";
import { EXTERNAL_NOTE } from "MODULES/PurchaseOrders/constants";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { modifiedAt } from "MODULES/shared/components/AuditFields/AuditFields";
import { EditInternalNote, EditExternalNote } from "./Edit";

const updatedBy = (record, field) => (
  <span>
    Last Edited: {modifiedAt(get(record, `${field}_audit.updated_at`))} by{" "}
    {getFirstNameLastInitial(
      get(record, `${field}_audit.updated_by.full_name`)
    )}
  </span>
);

const AuditFields = ({ record, field }) => (
  <p className="text-muted small">
    <em>{updatedBy(record, field)}</em>
  </p>
);

function Note({ header, record, type, update }) {
  return (
    <div>
      <h2>
        {header}
        {type === INTERNAL_NOTE && (
          <EditInternalNote
            record={record}
            update={update}
            spanClass=""
            text="Edit"
            buttonIcon="fa-plus"
            buttonClass="btn-primary btn-hollow pull-right"
          />
        )}

        {type === EXTERNAL_NOTE && (
          <EditExternalNote
            record={record}
            update={update}
            spanClass=""
            text="Edit"
            buttonIcon="fa-plus"
            buttonClass="btn-primary btn-hollow pull-right"
          />
        )}
      </h2>
      {![null, ""].includes(record[type]) && (
        <div className="panel panel-default panel-note">
          {record[`${type}_audit`] && (
            <div className="panel-heading">
              <AuditFields record={record} field={type} />
            </div>
          )}
          <div className="panel-body">{record[type]}</div>
        </div>
      )}
    </div>
  );
}

Note.propTypes = {
  record: T.shape({
    internal_note: T.string,
    external_note: T.string
  }).isRequired,
  header: T.string.isRequired,
  type: T.string.isRequired,
  update: T.func
};

export default Note;



// WEBPACK FOOTER //
// ./app/modules/shared/components/Note/Note.jsx